import styled from 'styled-components';

export const ReportContainer = styled.div`
  height: calc(100vh - 100px);
  position: relative;
  //width: 1600px;
  //margin: 0 auto;
`;
ReportContainer.defaultProps = {
    "data-id": "ReportContainer"
}

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const Col = styled.div`
  flex: 1;
  padding: 10px;
`;

export const Inner = styled.div`
  width: 1600px;
  max-width: 100%;
  margin: 0 auto;
`;

export const Header = styled.div`
  textAlign: left;
  padding: 0px 10px 0 10px;
  display: flex;
  justifyContent: center;
  alignItems: center;
  flexDirection: row;
`;

export const MainContainer = styled.div`
  display: flex;
  height: calc(100vh - 100px);
  flexDirection: row;
  align-items:   flex-start;
  max-width: 1600px;
  //margin-left: auto;
  //margin-right: auto;
  margin-top: 0px;
  margin-bottom: 0px;
  @media(max-width: 1199px) {
    width: 100%;
    overflow-x: scroll;
  }
  flex-direction: column;
`;
MainContainer.defaultProps = {
    "data-id": "MainContainer"
}

export const HeaderLeft = styled.div`
  display: flex;
  flex: 1;
`;

export const Alert = styled.div`
  padding: 10px;
  width: 350px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const TextAlert = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GroupControls = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const styles = theme => ({
    headerTitle: {
        fontSize: "1.5rem",
        fontWeight: 600,
    },
    container: {
        backgroundColor: '#fff'
    },
    formControl: {
        display: 'block',
    },
    select: {
        minWidth: 200,
    },
    dialog: {
        minWidth: 500,
    },
    close: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
    },
    dialogContainer: {
        padding: theme.spacing(2, 3),
    },
    table: {
        border: '1px solid #eaeaea',
        maxHeight: '60vh',
    },
    wrapper: {
        border: '1px solid #eaeaea',
    },
    notice: {
        color: 'red',
        fontSize: 13,
        fontStyle: 'italic',
    },
    error: {
        color: 'red',
        textAlign: 'center',
    },
    link: {
        fontSize: 12,
        color: '#2196f3',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    loadingOverlay: {
        position: "absolute",
        top: 0, left: 0, bottom: 0, right: 0,
        backgroundColor: 'rgba(200, 200, 200, 0.5)',
        zIndex: 99,
    },
    loading: {
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
    },
    alertContainerStyle: {
        borderRadius: 5
    },
    control: {
        margin: '0 3px 5px'
    },
});

export default styles;


